<template>
  <div class="buscador-ofertas-energia">
    <MisComisionesFiltros ref="filtrosRef" @filtrar="onFiltrar" />
    <MisComisionesResultados ref="resultadosRef" :filtros-aplicados="filtrosAplicados" />
  </div>
</template>

<script setup lang="ts">
import type { OfertasEnergiaRetribucionesListFiltrosModel } from "@/.shared/.api";
import MisComisionesFiltros from "@/components/mis-datos/MisComisionesFiltros.vue";
import MisComisionesResultados from "@/components/mis-datos/MisComisionesResultados.vue";
import { ref } from "vue";

const filtrosAplicados = ref<OfertasEnergiaRetribucionesListFiltrosModel | null>(null);

async function onFiltrar(filtros: OfertasEnergiaRetribucionesListFiltrosModel): Promise<void> {
  filtrosAplicados.value = filtros.Comercializadora ? filtros : null;
}
</script>

<style lang="scss" scoped>
.buscador-ofertas-energia {
  display: grid;
  grid-template-rows: auto 1fr;
  height: 100%;
  min-height: 0;
  overflow: hidden;

  > :last-child {
    min-height: 0;
    overflow: hidden;
  }
}
</style>
